import { render, staticRenderFns } from "./jobGroup__form.vue?vue&type=template&id=0ecd5ed6"
import script from "./jobGroup__form.vue?vue&type=script&lang=js"
export * from "./jobGroup__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports